import { BANNERNOW_SOURCE } from '../enums';

export const getBannerNowSource = (isDesktop: boolean, isCasinoDomain: boolean) => {
  if (isCasinoDomain) {
    return isDesktop ? BANNERNOW_SOURCE.DESKTOP_CASINO : BANNERNOW_SOURCE.MOBILE_CASINO;
  }

  return isDesktop ? BANNERNOW_SOURCE.DESKTOP : BANNERNOW_SOURCE.MOBILE;
};
